// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestinationSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataModelSettings component
 */

import React from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';

import Panel from 'share/components/controls/Izenda.Panel';
import SourceDestination from './Izenda.SourceDestination';
import SourceDestinationSettingsHeader from './Izenda.SourceDestinationSettingsHeader';
import Mapping from '../Mapping/Izenda.Mapping';
import constants from 'logic/data/Izenda.CopyManagementConstants';
import actions from './Izenda.SourceDestinationSettingsActions';

import localizer from 'share/localization/Izenda.Localizer';

function SourceDestinationSettings(props: any): any {
  const { store, item } = props;
  const title = props.buildTitle(props);

  const header = {
    title: title,
    icon: 'icon-toggle-triangle',
    className: 'u_noPaddingLeft u-bgGray',
    component: SourceDestinationSettingsHeader
  };

  const isShowDataModelSection =  !item.copyOnlySettings && (item.copyDataConnector || item.copyDataModel || item.copyDashboard || item.copyReport);

  // this section is used for copy data model, copy dashboard and copy report
  if (!isShowDataModelSection) {
    return null;
  }

  const showCopyPositionId = item.copyDataModel
  const showCopyFilterValues = item.copyReport || item.copyDashboard;
  const showAdditionalSettings = showCopyPositionId || showCopyFilterValues;

  const onCopyPositionIdCheck = function(e: any): void {
    item.setCopyPositionId(e.target.checked);
  };

  const onCopyFilterValuesCheck = function(e: any): void {
    item.setCopyFilterValues(e.target.checked);
  };

  return (
    <Panel
      collapsible
      header={header}
      className='u_fullWidth'
      expanedOption
      id={constants.MODULE_ANCHORS.DATA_MODEL_SETTING}>
      {showAdditionalSettings && (
        <div className='u_marginBottom'>
          {showCopyPositionId && (
            <span>
              <label className='u_noMarginBottom'>
                <input
                  type='checkbox'
                  checked={item.copyPositionId}
                  onChange={onCopyPositionIdCheck}
                  className='u_noMarginTop u_noMarginLeft u_alignMiddle'
                />
                <span className='u_paddingRight u_alignMiddle u_textNormal u_inlineBlock'>{localizer.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_COPY_RELATIONSHIP_POSITION_ID')}</span>
              </label>
            </span>
          )}
          {showCopyFilterValues && (
            <span>
              <label className='u_noMarginBottom'>
                <input
                  type='checkbox'
                  checked={item.copyFilterValues}
                  onChange={onCopyFilterValuesCheck}
                  className='u_noMarginTop u_noMarginLeft u_alignMiddle'
                />
                <span className='u_paddingRight u_alignMiddle u_textNormal u_inlineBlock'>{localizer.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_COPY_FILTER_VALUES')}</span>
              </label>
            </span>
          )}
        </div>
      )}
      <SourceDestination
        store={store}
        item={item} />
      {item.showMappingGrid &&
        <Mapping
          store={store}
          item={item}
          dataSource={item.workspaceMappings}
          addMapping={item.addWorkspaceMapping.bind(item)} />
      }
    </Panel>
  );
}

SourceDestinationSettings.propTypes = {
  store: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired
};

export default connect(actions)(SourceDestinationSettings);


// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/Izenda.SourceDestinationSettings.js